import Card from "components/DesignSystem/Card/Card";
import React from "react";

const LoaderRow = () => (
  <div className="t-flex t-justify-between t-items-center t-border t-border-solid t-border-t-0 t-border-l-0 t-border-r-0 t-border-neutral-0 t-py-2 t-px-4">
    <div className="t-flex t-gap-2 t-items-center t-w-full">
      <div className="t-relative t-h-10 t-w-10 t-rounded-full t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
      <div className="t-w-full t-space-y-2">
        <div className="t-bg-neutral-20 t-w-4/5 t-h-6 t-rounded t-animate-pulse"></div>
        <div className="t-flex t-gap-5">
          <div className="t-bg-neutral-20 t-w-1/3 t-h-4 t-rounded t-animate-pulse"></div>
          <div className="t-bg-neutral-20 t-w-1/3 t-h-4 t-rounded t-animate-pulse"></div>
        </div>
      </div>
    </div>
    <div className="t-relative t-h-8 t-w-20 t-rounded-lg t-flex t-items-center t-justify-center t-bg-neutral-20 t-animate-pulse"></div>
  </div>
);

export const TodoListLoader = () => {
  return (
    <div className="t-py-4 t-px-2" data-testid="loader-todolist">
      <div className="t-py-3 t-text-subtext t-text-text-60 t-border t-border-solid t-border-t-0 t-border-l-0 t-border-r-0 t-border-neutral-0">
        <div className="t-bg-neutral-20 t-w-32 t-h-5 t-rounded t-animate-pulse"></div>
      </div>
      <LoaderRow />
      <LoaderRow />
      <LoaderRow />
      <LoaderRow />
    </div>
  );
};
